import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { MAIN_SITE_URL } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="w-full border-t border-foreground-200/70 bg-primary-950">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-grid-fill text-lg"></i>
              </span>
              <span className="font-heading text-base font-bold text-background-50">
                USFans Spreadsheet
              </span>
            </Link>
            <p className="mt-4 max-w-md text-sm text-background-200">
              {t("footer.tagline")}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              {t("footer.explore")}
            </h4>
            <ul className="mt-4 space-y-3">
              <li>
                <Link to="/#categories" className="text-sm text-background-200 transition-colors hover:text-background-50">
                  {t("nav.categories")}
                </Link>
              </li>
              <li>
                <Link to="/#guides" className="text-sm text-background-200 transition-colors hover:text-background-50">
                  {t("nav.guides")}
                </Link>
              </li>
              <li>
                <Link to="/#faq" className="text-sm text-background-200 transition-colors hover:text-background-50">
                  {t("nav.faq")}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              {t("footer.resources")}
            </h4>
            <ul className="mt-4 space-y-3">
              <li>
                <a
                  href={MAIN_SITE_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-1 text-sm text-background-200 transition-colors hover:text-background-50"
                >
                  {t("footer.mainSite")}
                  <i className="ri-external-link-line"></i>
                </a>
              </li>
              <li>
                <Link to="/guide/usfans-spreadsheet-guide" className="text-sm text-background-200 transition-colors hover:text-background-50">
                  {t("guides.title")}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-background-800 pt-6">
          <p className="text-xs leading-relaxed text-background-300">
            {t("footer.disclaimer")}
          </p>
          <p className="mt-4 text-xs text-background-400">
            © {new Date().getFullYear()} USFans Spreadsheet. {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
}